module.exports = __webpack_public_path__ + "static/jesper-findahl-5bbf3040fad819847921425d50719907.jpg";